import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { AppRoutes, AppShell } from "~/App";

import "@fontsource/roboto/300.css";

const root = document.getElementById("root") as HTMLElement;
const app = (
    <AppShell>
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    </AppShell>
);

if (root.hasChildNodes()) {
    hydrateRoot(root, app);
} else {
    createRoot(root).render(app);
}

